import clsx from 'clsx';
import { useState, useEffect } from 'react';
import createApolloClient from '../../../api';
import getAllTactics from '../../../api/queries/tactics/getAllTactics';
import sanitizeHTML from '../../../utils/sanitiseHTML';
import { ReactComponent as PlusIcon } from '../../../public/images/plus-icon.svg';
import { ReactComponent as MinusIcon } from '../../../public/images/minus-icon.svg';

const client = createApolloClient();

const Tactics = () => {
  const [tactics, settactics] = useState([]);
  const [accordion_1, setaccordion_1] = useState('');
  const [accordion_2, setaccordion_2] = useState('');

  const handleToggle = (i) => () => {
    return accordion_1 === i ? setaccordion_1('') : setaccordion_1(i);
  };
  const handleToggle2 = (i) => () => {
    return accordion_2 === i ? setaccordion_2('') : setaccordion_2(i);
  };

  useEffect(() => {
    (async () => {
      const { data } = await client.query(getAllTactics());
      const { tactics } = data;
      settactics(tactics);
    })();
  }, []);

  return (
    <div className="section__tactics">
      {tactics?.nodes?.map((tactics, i) => {
        const classes = clsx({
          'templates__list__topic--open': accordion_1 === i,
        });
        return (
          <div key={tactics.title} id={tactics.title.toLowerCase()} className="section__tactics__accordion">
            <div className={`section__tactics__accordion__title ${classes}`}>
              {accordion_1 === i ? (
                <>
                  <MinusIcon onClick={handleToggle(i)} />
                </>
              ) : (
                <>
                  <PlusIcon onClick={handleToggle(i)} />
                </>
              )}
              <p className="section__tactics__accordion__title__text" onClick={handleToggle(i)}>
                <b>{tactics.title}</b>
              </p>
            </div>
            {accordion_1 === i && (
              <div className="section__tactics__accordion__body">
                {tactics.tactics.tacticsAnswers.map((tacticsAnswers, i) => {
                  const classes = clsx({
                    'templates__list__topic--open': accordion_2 === i,
                  });
                  return (
                    <div>
                      <div className={`section__tactics__accordion__body__title ${classes}`}>
                        {accordion_2 === i ? (
                          <>
                            <MinusIcon onClick={handleToggle2(i)} />
                          </>
                        ) : (
                          <>
                            <PlusIcon onClick={handleToggle2(i)} />
                          </>
                        )}
                        <p onClick={handleToggle2(i)}>
                          <b>{tacticsAnswers.tacticsAnswerTitle}</b>
                        </p>
                      </div>
                      {accordion_2 === i && (
                        <div className="section__tactics__accordion__body__content">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(tacticsAnswers.tacticsAnswerDescription),
                            }}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Tactics;
